<template>
  <!-- Reset password -->
  <div class="mt-16">
    <v-form @submit.prevent="updatePassword" v-model="isFormValid" ref="form">
      <h3 class="mb-3">Change password</h3>
      <div class="mb-1 subtitle-2 grey3--text">Current password</div>
      <v-text-field
        v-model="currentPassword"
        placeholder="Current password"
        :append-icon="showCurrentPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showCurrentPassword ? 'text' : passwordFieldType"
        @click:append="toggleCurrentPasswordVisibility"
        outlined
        dense
      ></v-text-field>
      <div class="mb-1 subtitle-2 grey3--text">New password</div>
      <v-text-field
        v-model="password"
        placeholder="Password"
        :rules="passwordRules"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPassword ? 'text' : passwordFieldType"
        @click:append="togglePasswordVisibility"
        outlined
        dense
      ></v-text-field>
      <div class="mb-1 subtitle-2 grey3--text">Confirm password</div>
      <v-text-field
        v-model="passwordConfirm"
        placeholder="Password"
        :rules="passwordConfirmRules"
        :append-icon="showPasswordConfirm ? 'mdi-eye' : 'mdi-eye-off'"
        :type="showPasswordConfirm ? 'text' : passwordFieldType"
        @click:append="togglePasswordConfirmVisibility"
        outlined
        dense
      ></v-text-field>

      <v-btn
        class="mt-2 primary white--text lowercase-text"
        block
        plain
        :loading="$store.state.loading.updatePasswordBtn.load"
        :disabled="$store.state.loading.updatePasswordBtn.disabled"
        type="submit"
      >
        Set new password
      </v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      currentPassword: "",
      showCurrentPassword: false,
      password: "",
      showPassword: false,
      passwordConfirm: "",
      showPasswordConfirm: false,
      passwordFieldType: "password",
      isFormValid: false,
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => v.length >= 8 || "Password must be at least 8 characters",
        (v) =>
          /[A-Z]/.test(v) ||
          "Password must contain at least one uppercase letter",
        (v) =>
          /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
          "Password must contain at least one special character",
      ],
      passwordConfirmRules: [
        (v) => !!v || "Password confirmation is required",
        (v) => v === this.password || "Passwords do not match",
      ],
    };
  },
  methods: {
    async updatePassword() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        await this.$store.dispatch("updatePassword", {
          passwordCurrent: this.currentPassword,
          password: this.password,
          passwordConfirm: this.passwordConfirm,
        });
        this.currentPassword = "";
        this.password = "";
        this.passwordConfirm = "";
      }
    },
    toggleCurrentPasswordVisibility() {
      this.showCurrentPassword = !this.showCurrentPassword;
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    togglePasswordConfirmVisibility() {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 20px;
}
</style>
